import { gql } from '@apollo/client';

export const CHECK_EXISTING_DCDD_USER = gql`
    query CheckForDcddExistingUser($field:String, $value:String) {
    CheckForDcddExistingUser(field: $field, value: $value) {
        data {
            exist_user
            user_id
        }
        error {
            code
            field
            message
        }
    }
}

`;
export const FETCH_PROFILE_BY_USER_ID = gql`
   query FetchProfileByDcddUserId($user_id:UUID) {
    FetchProfileByDcddUserId(user_id: $user_id) {
         data {
            user_profile {
                cid
                created_at
                dob
                dzongkhag_id
                eccd_id
                gender
                grade_id
                id
                name
                profile_picture
                student_id
                updated_at
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;
export const FETCH_DCDD_USERS = gql`
    query FetchAllDcddUsers($limit: Int, $offset: Int) {
        fetchAllDcddUsers(limit:$limit, offset:$offset) {
            error {
            message
            code
            field
        }
        data {
            users {
                login_id
                student_id
                category
                created_at
                email
                mobile_no
                status
                id
                user_identifier
                password
                updated_at
                user_profile {
                    student_id
                    dzongkhag_id
                    updated_at
                    id
                    created_at
                    profile_picture
                    eccd_id
                    dob
                    name
                    grade_id
                    cid
                    gender
                    dzongkhag {
                        name
                        id
                    }
                    grade {
                        id
                        name
                    }
                    school {
                        id
                        name
                        pvt_public
                    }
                    eccd {
                        id
                        name
                        sort
                    }
                }
            }
        }
        }
    }
`;

export const FETCH_DCDD_ACTIVE_USERS = gql`
    query GetDcddUserActivity($limit:Int, $offset:Int) {
    GetDcddUserActivity(limit: $limit, offset: $offset) {
        data {
            grouped_user_activities {
                user_id
                month
                year
                total_count
                activity_counts {
                    video_watched
                    others
                    CheyChey
                }
                user {
                    student_id
                    category
                    updated_at
                    email
                    created_at
                    id
                    status
                    login_id
                    password
                    user_identifier
                    mobile_no
                    user_profile {
                        profile_picture
                        eccd_id
                        name
                        dob
                        dzongkhag_id
                        cid
                        grade_id
                        gender
                        created_at
                        id
                        student_id
                        updated_at
                        school {
                            pvt_public
                            id
                            name
                        }
                        dzongkhag {
                            id
                            name
                        }
                        grade {
                            name
                            id
                        }
                        eccd {
                            name
                            sort
                            id
                        }
                    }
                }
            }
        }
        error {
            message
            code
            field
        }
    }
}

`;
export const FETCH_DCDD_USERS_BY_DATE_RANGE = gql`
 query FetchDcddUsersByDateRange($fromDate:String!,$toDate:String!) {
    FetchDcddUsersByDateRange(fromDate: $fromDate, toDate: $toDate) {
      data {
            user {
                category
                created_at
                email
                id
                login_id
                mobile_no
                password
                status
                student_id
                updated_at
                user_identifier
            }
            user_profile {
                cid
                created_at
                dob
                dzongkhag_id
                eccd_id
                gender
                grade_id
                id
                name
                profile_picture
                student_id
                updated_at
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;

export const FETCH_DZONGKHAG = gql`
 query FetchDzongkhag {
    fetchDzongkhag {
        data {
            dzongkhags {
                id
                name
            }
        }
        error {
            field
            message
            code
        }
    }
}

`;
export const FETCH_ECCD = gql`
 query FetchEccd($dzongkhag_id:UUID!) {
    fetchEccd(dzongkhag_id: $dzongkhag_id) {
        data {
            eccd {
                id
                name
                sort
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;
export const FETCH_GRADES = gql`
 query FetchGrade {
    fetchGrade {
        data {
            grade {
                id
                name
            }
        }
        error {
            code
            field
            message
        }
    }
}

`;
export const FETCH_SCHOOLS = gql`
query FetchSchools($dzongkhag_id:UUID!) {
    fetchSchools(dzongkhag_id: $dzongkhag_id) {
        data {
            school {
                id
                name
                pvt_public
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;